import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import TextField from '../TextField'
import Select from '../Select/Select'

import screenType from 'component/menuMission/screenType'
import Form from 'component/utils/Form'
import Modal from '../Modal'

import { arraysEqual } from 'utils/validations'
import { onlyNumbers } from 'utils/masks'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { renderToastWarn } from 'utils/ToastUtils'

const FIELDS = [
  'cdMission',
  'dsLdap',
  'dsProfile',
  'lsCdMenus',
  'nmMissions',
  'type',
]
/*eslint-disable */
const EditModal = ({
  allPermissions = [],
  appPermissions = [],
  closeModal,
  fields,
  handleOpenWarningModal,
  initialValues,
  missions,
  setValueToField,
  submit,
  translate,
  values,
  values: {
    cdMission,
    dsLdap,
    nmMissions,
    dsProfile,
    type = screenType.CREATE_PERSONAL_PROFILE_TYPE,
  },
  webPermissions = [],
  token,
  showWarning,
}) => {
  const IS_NEW_MISSION = -999

  const appPermissionsOptions = appPermissions.map((p) => ({
    value: p.cdMenu,
    order: p.cdMenuParent,
    label: !!p.dsMenuParent ? p.dsMenuParent + '  >  ' + p.dsMenu : p.dsMenu,
  }))

  const webPermissionsOptions = webPermissions.map((p) => ({
    value: p.cdMenu,
    label: !!p.dsMenuParent
      ? translate(p.dsMenuParentNotTranslated) +
        '  >  ' +
        translate(p.dsMenuNotTranslated)
      : translate(p.dsMenuNotTranslated),
  }))

  const missionsOptions = missions.map((m) => ({
    value: m.cdMission,
    label: m.dsMission,
  }))

  const [selectedAppPermissions, setSelectedAppPermissions] = useState([])
  const [selectedWebPermissions, setSelectedWebPermissions] = useState([])
  const [selectedAllPermissions, setSelectedAllPermissions] = useState([])
  const [blockAll, setBlockAll] = useState(false)

  useEffect(() => {
    if (
      initialValues.selectedAppPermissions ||
      initialValues.selectedWebPermissions
    ) {
      setSelectedAppPermissions(initialValues.selectedAppPermissions)
      setSelectedWebPermissions(initialValues.selectedWebPermissions)
    }
  }, [])

  const isSubmitDisabled = () => {
    if (blockAll) return true
    return (
      (!dsLdap && !cdMission && !nmMissions) ||
      !dsProfile ||
      (!selectedAppPermissions.length && !selectedWebPermissions.length)
    )
  }

  const checkChangedFields = () => {
    const checkField = (currentField, fieldName) => {
      return currentField && currentField !== initialValues[fieldName]
    }

    return (
      checkField(dsLdap, 'dsLdap') ||
      checkField(cdMission, 'cdMission') ||
      nmMissions ||
      checkField(dsProfile, 'dsProfile') ||
      !arraysEqual(
        selectedAppPermissions,
        initialValues.selectedAppPermissions
      ) ||
      !arraysEqual(selectedWebPermissions, initialValues.selectedWebPermissions)
    )
  }

  const beforeSubmit = () => {
    const param = {
      ...values,
      lsCdMenus: [...selectedAppPermissions, ...selectedWebPermissions],
    }

    if (cdMission) {
      param.lsCdMissions = [cdMission]
    }

    if (nmMissions) {
      param.lsNmMissions = [nmMissions]
    }

    submit(param)
  }

  const allPermissionsOptions = allPermissions
    .map((p) => ({
      value: p.dsProfile,
      label: p.dsProfile,
      lsCdMenus: p.lsCdMenus,
    }))

  const onClonePermissions = (option) => {
    const newSelectedAppPermissions = []
    const newSelectedWebPermissions = []

    let newValue = null

    if (option) {
      option.lsCdMenus.forEach((cdMenu) => {
        if (appPermissionsOptions.some((p) => p.value === cdMenu)) {
          newSelectedAppPermissions.push(cdMenu)
        } else {
          newSelectedWebPermissions.push(cdMenu)
        }
      })

      newValue = option.value
    }

    setSelectedAllPermissions(newValue)

    setSelectedAppPermissions(newSelectedAppPermissions)
    setSelectedWebPermissions(newSelectedWebPermissions)
  }

  const handleClose = () => {
    if (showWarning || checkChangedFields()) {
      const valuesToSave = {
        ...values,
        selectedAppPermissions,
        selectedWebPermissions,
      }

      handleOpenWarningModal(valuesToSave)
    } else {
      closeModal()
    }
  }

  const handleChangeMission = ({ value, label }) => {
    const mission = missions.find(({ cdMission }) => cdMission === value)

    if (mission) {
      setValueToField(fields.cdMission.input.name, value)

      setValueToField(fields.dsProfile.input.name, mission.dsMission)
    } else {
      setValueToField(fields.nmMissions.input.name, value)

      setValueToField(fields.dsProfile.input.name, value)
    }

    if (value === IS_NEW_MISSION) {
      setValueToField(fields.cdMission.input.name, value)
      setValueToField(fields.dsProfile.input.name, label)
      setValueToField(fields.nmMissions.input.name, '')
    }
  }

  const portal = { menuPortal: (base) => ({ ...base, zIndex: 9999 }) }

  const formatCreateLabel = (string) => {
    return `${translate('mission-list.create-option')} ${string}`
  }
  const onChangeLDAP = (e) => {
    setValueToField('dsLdap', e.target.value)
    if (e.target.value.length === 8) {
      const param = { dsLdap: e.target.value }
      new Api(token)
        .post(API_URL.MENU_MISSION_CHECKLIST, param)
        .then((data) => {
          if (data.cdStatus === 200) {
            setBlockAll(false)
          } else {
            setBlockAll(true)
            renderToastWarn(translate('missionMenu.validation.active'))
          }
        })
        .catch((error) => {
          setBlockAll(true)
          renderToastWarn(translate('missionMenu.validation.active'))
        })
    }
  }

  return (
    <Modal
      renderButton={false}
      size='lg'
      title={translate('missionMenu.addModal.title.' + type)}
      isOpen
      center={false}
      cancelButtonText={translate('close_button_label')}
      confirmButtonText={translate(
        type === screenType.CREATE_PERSONAL_PROFILE_TYPE ||
          type === screenType.CREATE_MISSION_PROFILE_TYPE
          ? 'register_button'
          : 'save_button_label'
      )}
      isConfirmButtonDisabled={isSubmitDisabled()}
      onConfirm={beforeSubmit}
      onCloseModal={handleClose}
      disabledBgClickClosing
    >
      {(type === screenType.CREATE_MISSION_PROFILE_TYPE ||
        type === screenType.EDIT_MISSION_PROFILE_TYPE) && (
        <div className='w-100'>
          <Select
            label={translate('missionMenu.addModal.field.cdMission.hint')}
            allowCreateWhileLoading={false}
            required
            fill
            disabled={type === screenType.EDIT_MISSION_PROFILE_TYPE}
            allowCreateOnSearch={
              type === screenType.CREATE_MISSION_PROFILE_TYPE
            }
            onChange={handleChangeMission}
            options={missionsOptions}
            placeholder={translate(
              'missionMenu.addModal.field.cdMission.placeholder'
            )}
            value={missionsOptions.find((m) => m.value === values.cdMission)}
          />
        </div>
      )}

      {(type === screenType.CREATE_PERSONAL_PROFILE_TYPE ||
        type === screenType.EDIT_PERSONAL_PROFILE_TYPE) && (
        <div className='w-100'>
          <TextField
            {...fields.dsLdap.input}
            onChange={onChangeLDAP}
            label={translate('missionMenu.addModal.field.dsLdap.hint')}
            className='form-control no-change-color'
            disabled={type === screenType.EDIT_PERSONAL_PROFILE_TYPE}
            mask={onlyNumbers()}
            maxLength={8}
            fill
            required
            placeholder={translate(
              'missionMenu.addModal.field.dsLdap.placeholder'
            )}
          />
        </div>
      )}

      {type !== screenType.CREATE_MISSION_PROFILE_TYPE &&
        type !== screenType.EDIT_MISSION_PROFILE_TYPE && (
          <div className='w-100'>
            <TextField
              fill
              required
              label={translate('missionMenu.addModal.field.dsProfile.hint')}
              {...fields.dsProfile.input}
              className='form-control no-change-color'
              disabled={blockAll}
              maxLength={100}
              placeholder={translate(
                'missionMenu.addModal.field.dsProfile.placeholder'
              )}
            />
          </div>
        )}
      <div className='w-100'>
        <Select
          label={translate('missionMenu.addModal.field.clone.hint.' + type)}
          required={false}
          disabled={blockAll}
          fill
          menuPlacement='top'
          onChange={onClonePermissions}
          options={allPermissionsOptions}
          placeholder={translate(
            'missionMenu.addModal.field.clone.placeholder.' + type
          )}
          value={allPermissionsOptions.find(
            (p) => p.value === selectedAllPermissions
          )}
        />
      </div>
      <div className='w-100'>
        <Select
          label={translate('missionMenu.addModal.webPermissions.hint')}
          required
          disabled={blockAll}
          fill
          menuPlacement='top'
          closeMenuOnSelect={false}
          isMulti
          menuPortalTarget={document.body}
          onChange={(options) => {
            setSelectedWebPermissions(
              options ? options.map((o) => o.value) : []
            )
          }}
          options={webPermissionsOptions}
          placeholder={translate(
            'missionMenu.addModal.webPermissions.placeholder'
          )}
          styles={portal}
          value={webPermissionsOptions
            .filter((p) => selectedWebPermissions.some((p2) => p2 === p.value))
            .sort(function (a, b) {
              if (a.order < b.order) return -1
              if (a.order > b.order) return 1
              return 0
            })}
        />
      </div>
      <div className='w-100'>
        <Select
          label={translate('missionMenu.addModal.appPermissions.hint')}
          required
          disabled={blockAll}
          fill
          menuPlacement='top'
          closeMenuOnSelect={false}
          isMulti
          menuPortalTarget={document.body}
          onChange={(options) =>
            setSelectedAppPermissions(
              options ? options.map((o) => o.value) : []
            )
          }
          options={appPermissionsOptions}
          placeholder={translate(
            'missionMenu.addModal.appPermissions.placeholder'
          )}
          styles={portal}
          value={appPermissionsOptions
            .filter((p) => selectedAppPermissions.some((p2) => p2 === p.value))
            .sort(function (a, b) {
              if (a.order < b.order) return -1
              if (a.order > b.order) return 1
              return 0
            })}
        />
      </div>
    </Modal>
  )
}

EditModal.propTypes = {
  allPermissions: PropTypes.array.isRequired,
  appPermissions: PropTypes.array.isRequired,
  closeModal: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  handleOpenWarningModal: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  missions: PropTypes.array.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  webPermissions: PropTypes.array.isRequired,
  token: PropTypes.string.isRequired,
}

export default Form({ fields: FIELDS })(EditModal)

export { EditModal }
